module.exports = __webpack_public_path__ + "static/media/ProfessionalContent.a52b68b1.svg";